import React from 'react';
import { postDesiginationData, updateDesiginationData } from '../../service/adminApi';
import { OnlyNumber, OnlySpecialChar } from '../../utils/RegHandling';

function DesiginationForm({ id, handleData, editData, hideContainer }) {
    const [desiginationName, setDesiginationName] = React.useState({});
    const [desiginationNameError, setDesiginationNameError] = React.useState('');
    const [flag, setFlag] = React.useState(false);

    React.useEffect(() => {

        if (editData?.id !== undefined) {
            setDesiginationName(editData);
        }
    }, [editData]);

    const resetData = () => {
        handleData('cancel');
        setFlag(!flag);
        setDesiginationName({ role: '' });
        hideContainer();
    };

    const addDesigination = async () => {
        let data = desiginationName;
        data['department_id'] = id;
        let response = '';
        if (validateDesigination()) {
            if (data.id === undefined) {
                response = await postDesiginationData(data);
            } else {
                response = await updateDesiginationData(data);
            }
            if (response.data.statusCode === 200) {
                handleData('update');
                hideContainer();
            }
        }
    };

    const validateDesigination = () => {
        let result = true;
        if (
            desiginationName === undefined ||
            desiginationName === '' ||
            !OnlyNumber(desiginationName) ||
            !OnlySpecialChar(desiginationName)
        ) {
            result = false;
            setDesiginationNameError('Enter a valid desigination name');
        }

        return result;
    };

    {

    }

    return (
        <div>
            <div className="offcanvas-header">
                <h5 className=" tt-bold font-16 announcement-offcanvas-color">
                    {editData?.id === undefined ? `Add new Designation` : `Edit Designation`}
                </h5>
                <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                    onClick={() => {
                        resetData();
                    }}
                />
            </div>
            <div className="offcanvas-body">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <label className="form-label hive-form-label" htmlFor="Announcement-Title">
                            Desigination
                            <span className="hive-form-mandatory">*</span>
                        </label>
                        <input
                            type="text"
                            className="form-control hive-form-control"
                            id="Announcement-Title"
                            placeholder="Enter a title"
                            value={desiginationName.role}
                            onChange={(e) => {
                                setDesiginationNameError('');
                                setDesiginationName((desiginationName) => ({ ...desiginationName, role: e.target.value }));
                            }}
                            name="role"
                        />
                        <span className="font-12 tt-bold text-danger">{desiginationNameError}</span>
                    </div>
                    <div className="d-flex justify-content-end mb-4 mt-5 p-0 ">
                        <button
                            onClick={() => {
                                resetData();
                            }}
                            className="btn hive-btn-secondary me-3"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={() => {
                                addDesigination();
                            }}
                            className="btn hive-btn-primary"
                            type="sumbit"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        >
                            {editData?.id === undefined ? 'Add' : 'Update'} Desigination{' '}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DesiginationForm;
